<template>
<v-app class="scroll">

    <vc-loading :processing="processing" :errors="errors" @close="processing=false;" />

    <div class="app-container app-theme-white">
        <transition name="fade" mode="out-in" appear>
            <Header :configUser="configUser" :user="user" @logout="logout()" />
        </transition>
        <transition name="fade" mode="out-in" appear>
            <div class="app-sidebar sidebar-shadow" @mouseover="toggleSidebarHover('add', 'closed-sidebar-open')" @mouseleave="toggleSidebarHover('remove', 'closed-sidebar-open')">
                <div class="app-header__logo" style="opacity:0.7">

                    <!-- <v-img lazy-src="" max-height="20" max-width="150" src="./../assets/images/logo22.png"></v-img> -->

                    <div class="header__pane ml-auto">
                        <button type="button" class="hamburger close-sidebar-btn hamburger--elastic" v-bind:class="{ 'is-active': isOpen }" @click="toggleBodyClass('closed-sidebar')">
                            <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="app-sidebar-content">
                    <VuePerfectScrollbar class="app-sidebar-scroll">
                        <sidebar-menu style="    font-family: Calibri;font-size: 14px;" showOneChild :menu="userMenu" />
                    </VuePerfectScrollbar>
                </div>
            </div>

        </transition>

        <div class="app-main__outer">
            <div class="app-main__inner">
                <v-main class="mb-10">
                    <v-container fluid class="pt-0 mt-0">
                        <page-title :icon="icon" style="height:62px"></page-title>
                        <router-view />
                    </v-container>
                </v-main>
            </div>
            <transition name="fade" mode="out-in">
                <Footer />
            </transition>
        </div>
    </div>
</v-app>
</template>

<script>
import Header from "@/components/Layout/Header";
import Footer from "@/components/Layout/Footer";
import Breadcrumb from "@/components/Layout/Breadcrumb.vue";
import {
    SidebarMenu
} from "vue-sidebar-menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

//Services
import _sAuth from "@/services/AuthService";

//Components
import PageTitle from "../components/Layout/PageTitle.vue";

export default {
    name: "App",
    components: {
        Header,
        Footer,
        Breadcrumb,
        SidebarMenu,
        VuePerfectScrollbar,
        PageTitle,
    },
    data() {
        return {
            usrName: "",
            user: {},
            userMenu: [],
            configUser: {},
            usrID: this.$fun.getUserID(),
            menu: [],
            isOpen: false,
            sidebarActive: false,
            collapsed: true,
            windowWidth: 0,
            user: {},
            icon: "pe-7s-home icon-gradient bg-amy-crisp",
            userInfo: null,
            processing: false,
            errors: null,
            timeToken: null,
            showLoginModal:false

        };
    },
    created() {
        this.usrName = localStorage.getItem("UsrName");
        this.initialize();
        this.configurateActivity();

        this.$eventBus.$on('sessionExpired', () => {
            this.showLoginModal = true
        });
    },
    methods: {

        initialize() {
            const storedMenu = JSON.parse(localStorage.getItem("UserOptions")) || [];
            this.userMenu = this.prepareMenu(storedMenu);
            this.userMenu.push({
                OptOrder: 0,
                header: true,
                title: "Menu",
            });
            this.userMenu.sort((x, y) => x.OptOrder - y.OptOrder);

            this.user = JSON.parse(localStorage.getItem("UserInfo")) || {};

            this.configUser = JSON.parse(localStorage.getItem("UserConfig")) || {};
            console.log("configUser", this.configUser);

            if (this.configUser.CfgLanguage != null) {
                localStorage.setItem("languaje", this.configUser.CfgLanguage);
            }
            if (this.configUser.CfgPersistent != null) {
                localStorage.setItem("persistent", this.configUser.CfgPersistent);
            }
            if (this.configUser.CfgAlertType != null) {
                localStorage.setItem("AlertType", this.configUser.CfgAlertType);
            }
            if (this.configUser.CfgAlertAlign != null) {
                localStorage.setItem("AlertAlign", this.configUser.CfgAlertAlign);
            }
            if (this.configUser.CfgToolbar != null) {
                localStorage.setItem("colorToolbar", this.configUser.CfgToolbar);
            }

            if (this.user.UsrExtern == 0 && (this.user.GenWorkerCE == undefined || this.user.GenWorkerCE == null)) {
                this.$fun.sweetAlert("[IMP]. Error algunos módulos no funcionaran de manera correcta.", "error")
            }

        },
        prepareMenu(options, level = 0) {
            return (options || [])
                .map((option) => this.prepareMenuOption(option, level))
                .filter((option) => option !== null);
        },
        prepareMenuOption(option, level = 0) {
            const route = this.findRouteByCode(option.OptCode);
            const child = this.prepareMenu(option.child || [], level + 1);
            const resolvedHref = route !== null ? route : this.findFirstChildRoute(child);
            const menuOption = {
                ...option,
                icon: option.OptIcon || option.icon || null,
            };

            if (resolvedHref !== null) {
                menuOption.href = resolvedHref;
            } else {
                delete menuOption.href;
            }

            if (level === 0) {
                menuOption.child = child;
                menuOption.childCount = child.length;
            } else {
                delete menuOption.child;
                delete menuOption.childCount;
            }

            if (menuOption.href || (level === 0 && child.length > 0) || menuOption.header === true) {
                return menuOption;
            }

            return null;
        },
        findFirstChildRoute(options) {
            for (const option of options || []) {
                if (option.href) {
                    return option.href;
                }
                const nestedHref = this.findFirstChildRoute(option.child || []);
                if (nestedHref) {
                    return nestedHref;
                }
            }

            return null;
        },
        findRouteByCode(optCode) {
            return this.$router.options.routes[1].children.find((route) => route.name === optCode) || null;
        },

        logout() {
            clearInterval(this.timeToken)
            localStorage.setItem("isIdle", false);
            localStorage.removeItem("token");
            localStorage.clear();

            this.$router.push(this.$const.baseHomeURL);

            /* if (this.usrExtern) {
                this.$router.push(this.$const.baseHomeURL);
            } else {
                this.$router.push("/micuenta");
            } */

        },

        toggleBodyClass(className) {
            const el = document.body;
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
        toggleSidebarHover(add, className) {
            const el = document.body;
            this.sidebarActive = !this.sidebarActive;

            this.windowWidth = document.documentElement.clientWidth;

            if (this.windowWidth > "992") {
                if (add === "add") {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            }
        },
        getWindowWidth() {
            const el = document.body;

            this.windowWidth = document.documentElement.clientWidth;

            if (this.windowWidth < "1350") {
                el.classList.add("closed-sidebar", "closed-sidebar-md");
            } else {
                el.classList.remove("closed-sidebar", "closed-sidebar-md");
            }
        },

        configurateActivity() {

            this.timeToken = setInterval(() => {
                if (this.usrID > 0) {
                    let time = localStorage.getItem("TimeTokenCount") - 3000;
                    localStorage.setItem("TimeTokenCount", time);
                    console.log(this.showLoginModal);

                    if (localStorage.getItem("TimeTokenCount") <= 3000) {
                        if (localStorage.getItem("token") != null && !this.showLoginModal) {

                            _sAuth.refreshToken({
                                UsrID: this.usrID
                            }).then((r) => {
                                localStorage.setItem("TimeTokenCount", 0);
                                localStorage.setItem("TimeTokenCount", localStorage.getItem("TimeToken"));
                                localStorage.setItem("token", "");
                                localStorage.setItem("token", r.data.Result.Data.Token);

                            });

                        }
                    }
                }
            }, 3000);
        },
    },
    watch: {
        $route(to, from) {},
    },

    mounted() {
        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);

            //Init
            this.getWindowWidth();
        });
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.getWindowWidth);
    },
};
</script>
